import React from "react";
import Modal from "./Modal";



export default function Section2(props) {
    return (
        <>

            <div className="section" data-aos="fade-up"
                data-aos-duration="3000">

                <section>

                    <h2>ATOS SIMPLES MAS QUE PODEM FAZER TODA A DIFERENÇA</h2>
                    <ul>
                        <li>Não jogue lixo nas ruas</li>
                        <li>Não desperdice água</li>
                        <li>Separe o lixo</li>
                        <li>Economize energia</li>
                    </ul>
                    <br />

                    <h2>FAZENDO A DIFERANÇA</h2>
                    <p>
                        Evitar o desperdício de água é importante não apenas nos momentos de crise. Adotar um estilo de vida e uma produção com uso racional da água é necessário não só hoje, como sempre. Isso porque as crises de água e energia que brasileiros têm enfrentado não são apenas resultado da seca.
                    </p>
                    <br />
                    <div className="img">
                        <img style={{ height: '30%', width: '90%' }} className="img" src={props.image2} />
                    </div>

                    <br />
                    <hr />
                    <br />

                    <h3 style={{ textAlign: 'center' }}>Aprenda a reutilizar os materiais que não usa mais</h3>
                    <br />
                    <div className="img">
                        <img style={{ width: '600px' }} src={props.image3} />
                    </div>

                    <br />

                    <div className="button">

                        <a href="https://voceconsciente.000webhostapp.com/reciclavel.html">
                            <button className='btn-success'>REUTILIZAR</button>
                        </a>
                    </div>
                    <hr />

                    <br />

                    <p>
                        Trabalhamos para transformar o mundo canino através da educação e conscientização.  Sonhamos com um mundo melhor para totós e humanos.
                    </p>

                    <div className="img">
                        <a href="https://totosdatete.org.br/totos-da-tete/o-que-fazemos/"> <img src={props.image4} /></a>


                    </div>

                    <br />

                    <a href="https://totosdatete.org.br/totos-da-tete/o-que-fazemos/"></a>

                    <hr />
                    <br />
                    <h2 style={{ textAlign: 'center' }}>VOCÊ EMPRESARÍO ESSA PÁGINA É PARA VOCÊ</h2>
                    <div className="button">
                        <a href="https://voceconsciente.000webhostapp.com/paraempresas.html"><button className='btn-success' color='danger'>PARA EMPRESAS</button></a>
                    </div>

                    <hr />

                    <Modal />

                </section>
            </div>
        </>

    )
}